import React, { useState, useEffect } from "react";
import styles from "./CategoriesCheckBox.module.css";

const CategoriesCheckBox = ({
  title,
  subcategories,
  onCategoryChange,
  onCategoryChange1,
  selectedCategoryFromCP,
  language,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [selected, setSelected] = useState(false);

  const [checkedItems, setCheckedItems] = useState(
    selectedCategoryFromCP ?? [],
  );
  const hasSubcategories = subcategories.length !== 0;

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (selectedCategoryFromCP) {
      setSelected(
        selectedCategoryFromCP && selectedCategoryFromCP.includes(title)
          ? true
          : false,
      );
    }
  }, [selectedCategoryFromCP, title]);

  const handleMainCategoryChange = (event) => {
    const isChecked = event.target.checked;
    setSelected(isChecked);
    if (isChecked) {
      let allSubcategories = subcategories.map(
        (subcategory) => subcategory.name,
      );
      if (allSubcategories.length !== 0) {
        let catList = allSubcategories;
        catList.push(title);
        onCategoryChange1(catList, isChecked);
      } else {
        onCategoryChange(title, isChecked);
      }
      setCheckedItems(allSubcategories);
    } else {
      setCheckedItems([]);
      const allSubcategories = subcategories.map(
        (subcategory) => subcategory.name,
      );
      if (allSubcategories.length !== 0) {
        let catList = allSubcategories;
        catList.push(title);
        onCategoryChange1(catList, isChecked);
      } else {
        onCategoryChange(title, isChecked);
      }
    }
  };

  const handleSubcategoryChange = (event, subcategory) => {
    const isChecked = event.target.checked;
    let updatedCheckedItems;
    if (isChecked) {
      updatedCheckedItems = [...checkedItems, subcategory];
    } else {
      updatedCheckedItems = checkedItems.filter((item) => item !== subcategory);
    }
    setCheckedItems(updatedCheckedItems);
    onCategoryChange(subcategory, event.target.checked);
  };

  return (
    <div
      className={`${styles.categoryBlock} ${
        expanded && hasSubcategories ? styles.categoryBlockExpanded : ""
      }`}
      style={{ marginLeft: hasSubcategories ? "0" : "0px" }}
    >
      <div
        className={`${styles.categoryFilter} ${
          hasSubcategories ? styles.categoryFilterExpandable : ""
        }`}
        onClick={handleExpand}
      >
        {hasSubcategories && (
          <span className={styles.arrow}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              style={{ transform: expanded ? "none" : "rotate(270deg)" }}
            >
              <path
                d="M1.41 0L6 4.59L10.59 0L12 1.42L6 7.42L0 1.42L1.41 0Z"
                fill="#CF9F47"
              />
            </svg>
          </span>
        )}

        <label
          className={`${styles.categoryName} ${
            selected ? styles.selectedCat : ""
          }`}
          style={{ paddingLeft: "0px" }}
        >
          <input
            type="checkbox"
            checked={selected}
            onChange={(event) => {
              handleMainCategoryChange(event);
            }}
            className="custom-checkbox"
          />{" "}
          {title}
        </label>
      </div>
      {expanded && (
        <div className={styles.subcategoryList}>
          {subcategories.map((subcategory, index) => {
            const subcategoryTitle =
              language === "ar"
                ? subcategory.item_group_name_ar
                : subcategory.name;
            const isChecked = checkedItems.includes(subcategory.name);
            const subcategoryHasChildren =
              (subcategory.children || []).length > 0;

            return (
              <label
                className={`${styles.checkCategory} ${
                  isChecked ? styles.selectedSubcategory : ""
                } ${
                  subcategoryHasChildren ? styles.checkCategoryExpandable : ""
                }`}
                key={subcategory.name || index}
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(event) => {
                    handleSubcategoryChange(event, subcategory.name);
                  }}
                  className="custom-checkbox"
                />
                <span className={styles.subcategoryText}>
                  {subcategoryTitle}
                </span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};
export default CategoriesCheckBox;
